// Thai-only build (thai-production): the app language is always Thai, so there
// is nothing to read from storage or from the user profile.
export const getStoredLanguage = (): string => "th";
